// 存放模型相关的工具函数

// 此时：接口返回的所有可选的模型列表
// https://api.gbase.ai/configs
// {
//   "default_models": [
//         {
//             "value": "gpt-4.1",
//             "label": "GPT-4.1",
//             "enabled": true
//         },
//         {
//             "value": "gpt-4.1-mini",
//             "label": "GPT-4.1 Mini",
//             "enabled": true
//         },
//         {
//             "value": "gpt-4o",
//             "label": "GPT-4o",
//             "enabled": true
//         },
//         {
//             "value": "claude-sonnet-4",
//             "label": "Claude 4 Sonnet",
//             "enabled": true
//         },
//         {
//             "value": "claude-3-7-sonnet",
//             "label": "Claude 3.7 Sonnet",
//             "enabled": true
//         },
//         {
//             "value": "gemini-2.5-pro",
//             "label": "Gemini 2.5 Pro",
//             "enabled": true
//         },
//         {
//             "value": "gemini-2.5-flash",
//             "label": "Gemini 2.5 Flash",
//             "enabled": true
//         },
//         {
//             "value": "gemini-2.0-flash",
//             "label": "Gemini 2.0 Flash",
//             "enabled": true
//         }
//     ]
// }

// 此时：从正式环境数据库中获取到的所有用户正在使用的 openai_model 列表。
// ["claude-3-7-sonnet", "claude-sonnet-4", "gpt-4.1", "gemini-2.5-flash",
//   "gpt-4o", "gemini-2.0-flash", "gpt-4.1-mini", "gpt_4o",
//   "claude_35_sonnet", "gpt_4_turbo", "gemini-2.5-pro"]

// 兼容：
// 1. 旧拼写方式的模型（比如：gpt_4o）
// 渲染前，映射成正确的拼写。
const typoModelMap = new Map<string, string>([['gpt_4o', 'gpt-4o']]);

// // 2. 旧模型（已不出现在接口返回的模型列表中，比如：gpt_4_turbo）
// // 对于旧模型，设置-模型-下拉框选项中仍旧展示旧模型。
// // P.S. 如果用户一旦选择新的模型，旧模型立刻会从列表中消失，没办法再选择回旧模型。
// const oldModelMap = new Map<string, { value: string; label: string; old: boolean }>([
//   ['claude_35_sonnet', { label: 'Claude 3.5 Sonnet', value: 'claude_35_sonnet', old: true }],
//   ['gpt_4_turbo', { label: 'GPT-4-Turbo', value: 'gpt_4_turbo', old: true }],
// ]);

/**
 * 获取有效的模型value，纠正旧的拼写方式。
 * @param value 模型名称
 * @returns 有效的模型名称
 */
export const getValidModelValue = (value?: string) => {
  if (!value) {
    return undefined;
  }

  return typoModelMap.has(value) ? typoModelMap.get(value) : value;
};

// 这个方案暂时不考虑，从后端解决（追加展示旧模型让用户选择，可能同时追加一个新的字段：旧模型不推荐）。

// /**
//  * 获取旧模型的下拉框选项，用于在设置-模型-下拉框选项中仍旧展示旧模型。
//  * P.S. 如果用户一旦选择新的模型，旧模型立刻会从列表中消失，没办法再选择回旧模型。
//  * @param value 模型名称
//  * @returns 旧模型
//  */
// export const getOldModel = (value?: string) => {
//   if (!value) {
//     return [];
//   }

//   return oldModelMap.has(value) ? [oldModelMap.get(value)!] : [];
// };
